import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "load-wrap ion-text-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "full-width ion-padding-horizontal" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "no-image ion-margin-vertical" }
const _hoisted_6 = { class: "ion-padding-horizontal" }
const _hoisted_7 = { class: "d-flex ion-align-items-center ion-margin-top" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "ion-padding-horizontal bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_z_summary = _resolveComponent("z-summary")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      ($data.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "lds-roller" }, [
              _createElementVNode("div"),
              _createElementVNode("div"),
              _createElementVNode("div"),
              _createElementVNode("div"),
              _createElementVNode("div"),
              _createElementVNode("div"),
              _createElementVNode("div"),
              _createElementVNode("div")
            ], -1),
            _createElementVNode("p", null, "Loading...", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    "icon-only": "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $data.arrowBack }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($data.pin.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "ion-no-padding ion-padding-top",
        fullscreen: ""
      }, {
        default: _withCtx(() => [
          (!$data.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_ion_item, { class: "a-pin-detail__img-wrapper ion-no-padding --transparent" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      ($data.slidesRendered)
                        ? (_openBlock(), _createBlock(_component_ion_slides, {
                            key: 0,
                            pager: true
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images, (image, i) => {
                                return (_openBlock(), _createBlock(_component_ion_slide, {
                                  class: "full-width",
                                  key: i,
                                  onClick: ($event: any) => ($options.openGalleryModal(i))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      class: "ion-margin-vertical",
                                      src: image
                                    }, null, 8, _hoisted_4)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128)),
                              ($options.images.length == 0)
                                ? (_openBlock(), _createBlock(_component_ion_slide, {
                                    class: "full-width",
                                    key: "placeholder"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_5, _toDisplayString($options.initials), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                            key: 1,
                            animated: "",
                            class: "ion-margin-vertical",
                            style: {"width":"100%","height":"200px"}
                          }))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  class: "ion-no-padding --transparent",
                  button: "",
                  "detail-icon": $data.caretForwardOutline,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.openCountry($data.pin.country?.id)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ion_label, { class: "ion-padding-vertical" }, {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createTextVNode(" Country ", -1)),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                              class: "z-flag ion-margin-end",
                              src: $data.pin.country?.flag.path
                            }, null, 8, _hoisted_8),
                            _createElementVNode("div", null, _toDisplayString($data.pin.country?.title), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["detail-icon"]),
                _createVNode(_component_ion_grid, { class: "ion-padding" }, {
                  default: _withCtx(() => [
                    ($data.pin.remarks)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { class: "ion-justify-content-between ion-align-items-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, { class: "ion-no-padding --transparent" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createElementVNode("div", { class: "ion-margin-top" }, "Remarks", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($data.pin.remarks)
                      ? (_openBlock(), _createBlock(_component_ion_row, {
                          key: 1,
                          class: "ion-padding-bottom"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { class: "ion-justify-content-between ion-align-items-center" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  innerHTML: $options._linkify($data.pin.remarks)
                                }, null, 8, _hoisted_9)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_row, { class: "ion-padding-bottom" }, {
                      default: _withCtx(() => [
                        (!$data.pin.diameter)
                          ? (_openBlock(), _createBlock(_component_ion_col, {
                              key: 0,
                              size: "6",
                              "size-md": "4",
                              class: "ion-justify-content-between ion-align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_z_summary, {
                                  label: 'Width (mm)',
                                  value: parseFloat($data.pin.width)
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!$data.pin.diameter)
                          ? (_openBlock(), _createBlock(_component_ion_col, {
                              key: 1,
                              size: "6",
                              "size-md": "4",
                              class: "ion-justify-content-between ion-align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_z_summary, {
                                  label: 'Height (mm)',
                                  value: parseFloat($data.pin.height)
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        ($data.pin.diameter)
                          ? (_openBlock(), _createBlock(_component_ion_col, {
                              key: 2,
                              size: "12",
                              class: "ion-justify-content-between ion-align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_z_summary, {
                                  label: 'Diameter (mm)',
                                  value: parseFloat($data.pin.diameter)
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_col, {
                          size: $data.pin.material?.title.length < $data.breakLength ? 6 : 12,
                          "size-md": "4",
                          class: "ion-justify-content-between ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_z_summary, {
                              label: 'Material',
                              value: $data.pin.material?.title
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["size"]),
                        _createVNode(_component_ion_col, {
                          size: "6",
                          "size-md": "4",
                          class: "ion-justify-content-between ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_z_summary, {
                              label: 'Production',
                              value: $data.pin.year_end ? `${$data.pin.year} - ${$data.pin.year_end}` : `${$data.pin.year}`
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: $data.pin.finish?.title.length < $data.breakLength ? 6 : 12,
                          "size-md": "4",
                          class: "ion-justify-content-between ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_z_summary, {
                              label: 'Finish',
                              value: $data.pin.finish?.title
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["size"]),
                        _createVNode(_component_ion_col, {
                          size: $data.pin.tacking?.title.length < $data.breakLength ? 6 : 12,
                          "size-md": "4",
                          class: "ion-padding-start ion-justify-content-between ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_z_summary, {
                              label: 'Fitting',
                              value: $data.pin.tacking?.title
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["size"]),
                        ($data.pin.event)
                          ? (_openBlock(), _createBlock(_component_ion_col, {
                              key: 3,
                              size: $data.pin.event?.title.length < $data.breakLength ? 6 : 12,
                              "size-md": "4",
                              class: "ion-justify-content-between ion-align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_z_summary, {
                                  label: 'Purpose of issue',
                                  value: $data.pin.event?.title
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }, 8, ["size"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_col, {
                          size: "6",
                          "size-md": "4",
                          class: "ion-justify-content-between ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_z_summary, {
                              label: 'Type',
                              value: $data.pin.official ? 'Official' : 'Unofficial'
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: $data.pin.manufacturer?.title.length < $data.breakLength ? 6 : 12,
                          "size-md": "4",
                          class: "ion-justify-content-between ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_z_summary, {
                              label: 'Manufacturer',
                              value: $data.pin.manufacturer?.title
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["size"]),
                        _createVNode(_component_ion_col, {
                          size: "6",
                          "size-md": "4"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ion_button, {
                    class: _normalizeClass( $data.pin.in_collection ? '--default --success' : '--default --danger'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.pinAction($data.pin)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($data.pin.in_collection ? 'Remove from my collection' : 'Add to my collection'), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}